import React, { createContext, useContext } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children, currentView, setCurrentView, navigateAfterAuth, externalRedirect, appId }) => (
  <AuthContext.Provider value={{ currentView, setCurrentView, navigateAfterAuth, externalRedirect, appId }}>
    {children}
  </AuthContext.Provider>
);

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within AuthProvider");
  }
  return context;
};
